// extracted by mini-css-extract-plugin
module.exports = {"Row":"SocialRow_Row__F7N6-","AccWrapper":"SocialRow_AccWrapper__1OxdU","IconWrapper":"SocialRow_IconWrapper__3B-YI","LinkWrapper":"SocialRow_LinkWrapper__3KIpU"};